/**
 * Angebote und Rechnungen bearbeitet man am Computer, nicht am Telefon
 * (Benjamin, 20.10.2026). Am Telefon: ansehen, versenden, Status setzen,
 * Projekt/Kunde zuordnen — aber keinen Inhalt ändern und nichts Neues anlegen.
 *
 * Ein Link in den Editor (neu anlegen oder festgeschriebenen Beleg ändern)
 * fällt am Telefon deshalb weg. Ein Entwurf bleibt erreichbar: seine Adresse
 * zeigt am Telefon eine Ansicht statt des Editors (`BelegAnsichtTelefon`).
 */
export function istEditorLink(ziel: string): boolean {
  return /^\/rechnungen\/neu(\?|$)/.test(ziel) || /^\/rechnungen\/beleg\/[^/]+\/bearbeiten/.test(ziel);
}
